'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var Button = require('@narvar/nth-block-button');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);

const ItemPhotoUploadButton = _ref => {
  let {
    onChangeFile
  } = _ref;
  const hiddenFileInput = React.useRef(null);
  const {
    claimsPhotoUploadButtonText
  } = nthHookTranslations.useTranslations();
  return /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React__default["default"].createElement("input", {
    type: "file",
    ref: hiddenFileInput,
    onChange: onChangeFile,
    multiple: true,
    style: {
      display: 'none'
    },
    "data-testid": "file-input",
    accept: "image/jpeg, image/jpg, image/png"
  }), /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
    onClick: () => {
      var _hiddenFileInput$curr;
      return (_hiddenFileInput$curr = hiddenFileInput.current) === null || _hiddenFileInput$curr === void 0 ? void 0 : _hiddenFileInput$curr.click();
    },
    big: true
  }, claimsPhotoUploadButtonText));
};
var ItemPhotosUploadButton = nthHookTranslations.withTranslationsProvider(ItemPhotoUploadButton, {
  translationKeys: ['claimsPhotoUploadButtonText']
});

exports["default"] = ItemPhotosUploadButton;
